import { render } from "./MyHeader2.vue?vue&type=template&id=7dfd1bcb&scoped=true"
import script from "./MyHeader2.vue?vue&type=script&lang=js"
export * from "./MyHeader2.vue?vue&type=script&lang=js"

import "./MyHeader2.vue?vue&type=style&index=0&id=7dfd1bcb&scoped=true&lang=css"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfd1bcb"]])

export default __exports__